<template>
    <q-card bordered class="card-shadow">
        <q-card-section class="bg-title-bar text-white">
            <div class="flex justify-between">
                <span class="text-h6">{{$t('users.rewards_summary')}}&nbsp;&nbsp;<q-badge outline color="yellow" :label="$t('new')" v-if="side === 'user'"/></span>
                <span v-if="refCode && side === 'operator'">
                    <q-btn
                        flat
                        dense
                        icon-color="white"
                        icon="far fa-copy"
                        :label="$t('users.reward_link')"
                        v-clipboard="invitation_link"
                        @click="$copied($t('field_is_copied', {field: $t('users.reward_link')}))"
                    />
                </span>
            </div>
        </q-card-section>

        <q-separator/>

        <q-card-section class="q-px-none">
            <q-list class="row">
                <q-item class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <q-item-section class="text-bold">
                        <q-item-label class="q-gutter-sm text-body1">
                            <span>{{$t('users.joined_friends')}}:</span>
                            <q-skeleton type="text" animation="blink" class="bg-grey" v-if="loading"/>
                            <span v-else>
                                <currency-format
                                class="text-bold text-primary inline-block"
                                :value="rewards.total_signed_up_friends"
                                hide-decimals
                                hide-white-spaces
                            /> {{rewards.total_signed_up_friends > 1 ? $t('users.rewarded_users'): $t('users.rewarded_user')}}</span>
                        </q-item-label>
                    </q-item-section>
                </q-item> <!-- Total signed up friends -->
                <q-item class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <q-item-section class="text-bold">
                        <q-item-label class="q-gutter-sm text-body1">
                            <span>{{$t('users.cash_earned')}}:</span>
                            <q-skeleton type="text" animation="blink" class="bg-grey" v-if="loading"/>
                            <span
                                v-else-if="rewards.cash_earned.length"
                                v-for="cash in rewards.cash_earned"
                                :key="cash.currency"
                            >
                                <currency-format
                                    class="text-bold text-primary inline-block"
                                    :value="cash.total"
                                    :unit="cash.symbol"
                                    hide-zero-decimal
                                    hide-white-spaces
                                />&nbsp;&nbsp;
                            </span>
                            <span class="text-primary text-bold" v-else>0</span>
                        </q-item-label>
                    </q-item-section>
                </q-item> <!--Cash Earned-->
                <q-item class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <q-item-section class="text-bold">
                        <q-item-label class="q-gutter-sm text-body1">
                            <span>{{$t('users.savings_to_date')}}:</span>
                            <q-skeleton type="text" animation="blink" class="bg-grey" v-if="loading"/>
                            <span
                                v-else-if="rewards.savings_to_date.length"
                                v-for="cash in rewards.savings_to_date"
                                :key="cash.currency"
                            >
                                <currency-format
                                    class="text-bold text-primary inline-block"
                                    :value="cash.total"
                                    :unit="cash.symbol"
                                    hide-zero-decimal
                                    hide-white-spaces
                                />&nbsp;&nbsp;
                            </span>
                            <span class="text-primary text-bold" v-else>0</span>
                        </q-item-label>
                    </q-item-section>
                </q-item> <!--Savings to date-->
                <q-item class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <q-item-section class="text-bold">
                        <q-item-label class="q-gutter-sm text-body1">
                            <span>{{$t('users.unused_rewards')}}:</span>
                            <q-skeleton type="text" animation="blink" class="bg-grey" v-if="loading"/>
                            <span
                                v-else-if="rewards.unused.length"
                                v-for="cash in rewards.unused"
                                :key="cash.currency"
                            >
                                <currency-format
                                    class="text-bold text-primary inline-block"
                                    :value="cash.total"
                                    :unit="cash.symbol"
                                    hide-zero-decimal
                                    hide-white-spaces
                                />&nbsp;&nbsp;
                            </span>
                            <span class="text-primary text-bold" v-else>0</span>
                        </q-item-label>
                    </q-item-section>
                </q-item> <!--Zero-fee transfers to use-->
            </q-list>
        </q-card-section>
    </q-card>
</template>
<script>

export default {
    name: "RewardsSummary",
    props: {
        rewards: {
            type: Object,
            required: true
        },
        refCode: {
            type: String,
            required: true
        },
        side: {
            type: String,
            default: 'user' // or operator
        }
    },
    computed: {
        invitation_link() {
            return `${process.env.DASHBOARD_URL}/auth/register?code=${this.refCode}`
        },
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {},
    created() {

    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
